import FerrySearchMaskStore from './store';
import {getRecentQueries} from 'providers/storage';
import {searchMaskTranslations} from 'ferries/helpers/translations';
import {isTravelplanet24} from 'helpers/stableValues';

export default function createSearchMaskStore({getPorts, onGetPorts = undefined}) {
  return new FerrySearchMaskStore({
    getRecentQueries,
    isTravelplanet24,
    getPorts,
    onGetPorts,
    translations: searchMaskTranslations
  });
}
